// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4541":"010522c7","9054":"2a6d2ca2"}[chunkId] + ".chunk.css";
};